import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { TrashIcon } from "@heroicons/react/24/outline";
import { integerName } from "../../app/utils";
import ButtonWithConfirm from "../../components/ButtonWithConfirm";
import { useDeleteCoursesMutation } from "../courses/coursesApiSlice";

interface DeleteProps {
	numSelectedCourses: number;
	selectedCourseIds?: number[];
	setErrorMessage: (message: string) => void;
	resetTable: () => void;
}

export default function DeleteCourseButton(props: DeleteProps) {
	const [deleteCourses] = useDeleteCoursesMutation();
	const [isDeleting, setIsDeleting] = useState(false);

	function handleDelete() {
		if (props.selectedCourseIds) {
			setIsDeleting(true);
			deleteCourses(props.selectedCourseIds)
				.unwrap()
				.then(() => {
					props.setErrorMessage("");
					setIsDeleting(false);
					props.resetTable();
				})
				.catch((error) => {
					setIsDeleting(false);
					props.resetTable();
					scrollTo(0, 0);
					props.setErrorMessage(
						`A server error occurred while deleting the course(s). ${error.data.innerMessage}`
					);
				});
		}
	}

	return (
		<>
			{isDeleting && (
				<div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
					<TailSpin
						visible={isDeleting}
						height="120"
						width="120"
						color="#4fa94d"
						ariaLabel="tail-spin-loading"
						radius="1"
						wrapperClass=" bg-gray-200/60 border-gray-200/60 rounded-lg p-4 z-10"
					/>
				</div>
			)}
			<ButtonWithConfirm
				id="delete-courses-button"
				disabled={props.numSelectedCourses === 0}
				message={`Are you sure you want to delete ${integerName(props.numSelectedCourses)} course${props.numSelectedCourses == 1 ? "" : "s"} from the school? This will remove all related data associated with the course, however please note that this action does not reclaim seats. If you want to free up seats before deleting the course, make the course inactive first.`}
				confirmLabel="Yes"
				cancelLabel="No"
				onConfirm={handleDelete}>
				<span className="flex items-center">
					<TrashIcon className="size-4 mr-2" /> Delete
				</span>
			</ButtonWithConfirm>
		</>
	);
}
